import styled from 'styled-components';
import { Button } from '@/components/UI/Button/Button';
import { IconBox } from '@/components/UI/IconBox/IconBox.styles';
import { CloseIcon } from '@/components/UI/Icons/Icons';
import { Typography } from '@/components/UI/Typography/Typography.styles';

export const AppPromotionModalContent = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  gap: 30px;
`;

export const AppPromotionModalCloseBtn = styled.button`
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  top: -51px;
  right: 0;
  width: 34px;
  aspect-ratio: 1/1;
  background: ${({ theme }) => theme.palette.system['black-50']};
  border-radius: 50%;
  border: none;

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    top: -42px;
    right: -52px;
    width: 42px;
    cursor: pointer;
  }
`;

export const AppPromotionModalCloseIcon = styled(CloseIcon).attrs(
  ({ theme }) => ({
    width: 16,
    fill: theme.palette.system.white,
  })
)`
  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    width: 14px;
    height: 14px;
  }
`;

export const AppPromotionModalBgImg = styled(IconBox).attrs({
  $filename: 'app_promotion_modal/background.jpg',
  $width: 380,
  $height: 190,
})`
  width: 100%;
  min-width: auto;
  border-radius: 27px;
`;

export const AppPromotionModalImg = styled(IconBox).attrs<{ $imgName: string }>(
  ({ $imgName }) => ({
    $filename: `app_promotion_modal/${$imgName}.png`,
    $width: 228,
    $height: 260,
    $iconWidth: 228,
    $iconHeight: 260,
  })
)`
  position: absolute;
  top: -50px;
  left: 50%;
  transform: translateX(-50%);
`;

export const AppPromotionModalTexts = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 15px;
  text-align: center;

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: 0 5px;
  }
`;

export const AppPromotionModalTitle = styled(Typography.Title).attrs({
  $variant: '4',
})`
  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    font-size: 26px;
  }
`;

export const AppPromotionModalDescription = styled(Typography.Body).attrs({
  $variant: '4',
})`
  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    font-size: 16px;
  }
`;

export const AppPromotionModalBtn = styled(Button).attrs({
  appearance: 'primary',
  isFullWidth: true,
  borderRadius: 14,
})`
  &:hover {
    @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
      background-color: ${({ theme }) => theme.palette.brand.mainOnHover};
    }
  }
`;
